import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../../../services/admin/admin.service';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent {
  email = '';
  password = '';
  showPassword = false;
  loading = false;
  loginError = '';

  constructor(private adminService: AdminService, private router: Router) {
    if (this.adminService.isLoggedIn()) {
      this.router.navigate(['/admin/dashboard']);
    }
  }

  onLogin(): void {
    this.loading = true;
    this.loginError = '';
    this.adminService.login(this.email, this.password).subscribe({
      next: (res) => {
        this.loading = false;
        if (res.status === 'success') {
          this.router.navigate(['/admin/dashboard']);
        } else {
          this.loginError = typeof res.data === 'string' ? res.data : (res.message || 'Login failed. Check credentials.');
        }
      },
      error: (err) => {
        this.loading = false;
        this.loginError =
          (typeof err?.error?.data === 'string' && err.error.data) ||
          err?.error?.message ||
          (typeof err?.error === 'string' && err.error) ||
          err?.message ||
          'Login failed. Check credentials.';
      }
    });
  }
}
